var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFileVideo = function SvgIconFileVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2A1.75 1.75 0 0 0 3.5 3.75v7.5a1 1 0 1 0 2 0V4h7.375v4.625a1 1 0 0 0 1 1H18.5V20h-.875a1 1 0 1 0 0 2h1.125a1.75 1.75 0 0 0 1.75-1.75v-12a1 1 0 0 0-.293-.707l-5.25-5.25A1 1 0 0 0 14.25 2zm9.625 3.04v2.585h2.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.394 15.148A1.75 1.75 0 0 0 9.75 14H4.5a1.75 1.75 0 0 0-1.75 1.75v3.75c0 .966.784 1.75 1.75 1.75h5.25a1.75 1.75 0 0 0 1.63-1.112l2.15.788a1 1 0 0 0 1.345-.938v-4.613a1 1 0 0 0-1.316-.949zM4.75 16v3.25H9.5V16zm6.75 1.22v.832l1.375.504v-1.794z"
  }))));
};
export default SvgIconFileVideo;